// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"456":"529b85a8","522":"085032b5","616":"2e82f6d3","716":"f6afe996","960":"7bb5a78c"}[chunkId] + ".chunk.css";
};